import React from 'react';
import { Button, SvgX } from '@grubhubprod/gh-cookbook-react';
import { ConfirmDialog } from 'src/components/enterprise/features/Employee/components/ConfirmDialog/ConfirmDialog';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';
import { useDeleteReport } from 'src/components/enterprise/features/Reporting/ManageReportsPage/components/ReportsWrapper/hooks/useDeleteReport';
import { ReportUI } from 'src/components/enterprise/features/Reporting/ManageReportsPage/utils/reportUI.utils';

interface DeleteReportButtonProps {
  corpId: string;
  exportId: string;
  exportName: string;
}

export const DeleteReportButton: React.FC<DeleteReportButtonProps> = ({
  corpId,
  exportId,
  exportName,
}) => {
  const { refresh } = useDataTableContext<ReportUI>();

  const { deleteReport, isDeleting } = useDeleteReport({
    corpId,
    onSuccess: refresh,
  });

  return (
    <ConfirmDialog
      title="Delete Report"
      description={`Are you sure you want to delete "${exportName}"? This action cannot be undone.`}
      confirmLabel="Delete"
      cancelLabel="Cancel"
      isLoading={isDeleting}
      onConfirm={(): Promise<void> => deleteReport(exportId)}
    >
      <Button
        variant="tertiary"
        type="button"
        className="tableActionButtons"
        aria-label={`Delete ${exportName}`}
        disabled={isDeleting}
        title={`Delete ${exportName}`}
        isLoading={isDeleting}
      >
        <SvgX size="20px" aria-hidden />
      </Button>
    </ConfirmDialog>
  );
};
